import type { SubscriptionDetails } from "schemas/generated/billing";

import * as React from "react";

import { Alert } from "@replo/design-system/blocks/alert/Alert";
import { skipToken } from "@tanstack/react-query";
import { billingRouter } from "@v2/trpc/routes/billing";
import { format } from "date-fns";

const SubscriptonCancelledNotEndedAlert = ({
  activeSubscription,
  workspaceId,
}: {
  activeSubscription?: SubscriptionDetails;
  workspaceId: string;
}) => {
  const { data: nextSubscriptionBillingDate } =
    billingRouter.getNextCorePlanBillingDate.useQuery(
      workspaceId && activeSubscription?.id
        ? {
            workspaceId,
            subscriptionId: activeSubscription.id,
          }
        : skipToken,
    );

  if (
    activeSubscription?.endedAt &&
    activeSubscription?.billingTier !== "free" &&
    nextSubscriptionBillingDate
  ) {
    return (
      <Alert
        variant="info"
        description={
          <p>
            You'll continue to have access to all features until{" "}
            <span className="inline font-bold">
              {nextSubscriptionBillingDate
                ? format(new Date(nextSubscriptionBillingDate), "MMMM d, yyyy")
                : "the end of your current billing period"}
            </span>
            . Your subscription will end after that, and you won't be charged
            again.
          </p>
        }
      />
    );
  }
};

export default SubscriptonCancelledNotEndedAlert;
